import React, { useState } from 'react'
import { Text, View } from 'react-native'
import styled from 'styled-components/native'
import TextInput from '../../../../components/common/TextInput'
import useTranslation from '../../../../hooks/useTranslation'
import { BlockSettingsProps, HelpText, SettingLabel } from '../settingsStyles'
import { builderColors } from '../builderColors'
import { safeLink } from '../../../../doclets/links'

// Image settings in the sidebar. The caption is edited on the canvas, under
// the image.
const ImageBlockSettings = ({
  block,
  onChange
}: BlockSettingsProps<'image'>) => {
  const { t } = useTranslation()
  const { alt, link } = block.props
  // Judged once the field is left, not mid-typing ("https://" alone is
  // refused, so checking every keystroke would flash the error). A link that
  // was already saved is judged straight away.
  const [linkChecked, setLinkChecked] = useState(() => !!link.trim())
  const linkRefused = linkChecked && !!link.trim() && !safeLink(link)

  return (
    <>
      <Field>
        <SettingLabel>{t('doclets:image:alt')}</SettingLabel>
        <TextInput
          placeholder=""
          value={alt}
          onChangeText={value => onChange({ ...block.props, alt: value })}
        />
        <HelpText style={{ marginTop: 6 }}>
          {t('doclets:image:altHelp')}
        </HelpText>
      </Field>
      <Field>
        <SettingLabel>{t('doclets:image:link')}</SettingLabel>
        <TextInput
          placeholder="https://"
          value={link}
          onChangeText={value => {
            setLinkChecked(false)
            onChange({ ...block.props, link: value })
          }}
          // Tidy as the field is left: "world50.com" -> "https://world50.com".
          // A refused link (javascript: etc.) is kept so it can be corrected;
          // the page never links it.
          onBlur={() => {
            setLinkChecked(true)
            const tidy = safeLink(link)
            if (tidy && tidy !== link) onChange({ ...block.props, link: tidy })
          }}
        />
        {linkRefused ? (
          <ErrorText>{t('doclets:image:linkRefused')}</ErrorText>
        ) : (
          <HelpText style={{ marginTop: 6 }}>
            {t('doclets:image:linkHelp')}
          </HelpText>
        )}
      </Field>
    </>
  )
}

const ErrorText = styled(Text)`
  margin-top: 6px;
  font-size: 11px;
  line-height: 15px;
  color: ${builderColors.danger};
`

const Field = styled(View)`
  padding: 12px 0;
  border-top-width: 1px;
  border-top-color: ${builderColors.border};
`

export default ImageBlockSettings
